import React from 'react';
import { Container, Row, Col, useAccordionButton, Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import pluralize from 'pluralize';
import parse from 'html-react-parser';

import { HealthQuote } from '@models/HealthQuote';

import { Title } from './title';

const Toggle = ({ children, eventKey }: { children: React.ReactNode; eventKey: string }) => {
  const handleClick = useAccordionButton(eventKey);

  return (
    <a className="c-pointer link-info" onClick={handleClick}>
      {children}
    </a>
  );
};

const ExclusionSection = ({ exclusionHtml }: Pick<HealthQuote, 'exclusionHtml'>) => {
  const { t } = useTranslation();

  return (
    <section className="pb-5 bg-light">
      <Accordion flush>
        <Title>
          <Toggle eventKey="0">{pluralize(t('common:exclusion'), 2)}</Toggle>
        </Title>
        <Accordion.Collapse eventKey="0">
          <Container>
            <Row>
              <Col lg={10} className="mx-auto">
                <>{parse(exclusionHtml)}</>
              </Col>
            </Row>
          </Container>
        </Accordion.Collapse>
      </Accordion>
    </section>
  );
};

export { ExclusionSection };
